import { AuthenticatedUser } from '../../models/authenticatedUser.models';

export interface AuthenticatedUserState {
  ids: string[];
  entities: Record<string, AuthenticatedUser>;
  selectedId: string | null;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_USER' }
  | {
      type: 'FETCH_USER_SUCCESS';
      payload: { user: AuthenticatedUser };
    }
  | { type: 'FETCH_USER_FAILURE'; payload: { error: string } }
  | { type: 'UPDATE_USER' }
  | {
      type: 'UPDATE_USER_SUCCESS';
      payload: { user: AuthenticatedUser };
    }
  | { type: 'UPDATE_USER_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: AuthenticatedUserState = {
  ids: [],
  entities: {},
  selectedId: null,
  isLoaded: false,
  isLoading: false,
  error: null,
};

export const authenticatedUserReducer = (
  state: AuthenticatedUserState,
  action: Action
): AuthenticatedUserState => {
  switch (action.type) {
    case 'FETCH_USER':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: !!state.ids.length,
      };
    case 'FETCH_USER_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [...new Set([...state.ids, action.payload.user.userId])],
        selectedId: action.payload.user.userId,
        entities: {
          ...state.entities,
          [action.payload.user.userId]: action.payload.user,
        },
      };
    case 'FETCH_USER_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    case 'UPDATE_USER':
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case 'UPDATE_USER_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        entities: {
          ...state.entities,
          [action.payload.user.userId]: action.payload.user,
        },
      };
    case 'UPDATE_USER_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
